import { motion } from "framer-motion";
import { bandColor, bandFor } from "@/lib/ui";

export const HealthGauge = ({ score = 0, band, size = 240, stroke = 16, label = "Corporate Health", testId = "health-score-gauge", display }) => {
  const b = band || bandFor(score);
  const color = bandColor(b);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const arc = c * 0.75;
  const filled = arc * (Math.max(0, Math.min(100, score)) / 100);
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="rotate-[135deg]">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--border))" strokeWidth={stroke}
          strokeDasharray={`${arc} ${c}`} strokeLinecap="round" />
        <motion.circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round"
          initial={{ strokeDasharray: `0 ${c}` }} animate={{ strokeDasharray: `${filled} ${c}` }}
          transition={{ duration: 1.2, ease: [0.2, 0.7, 0.2, 1] }} style={{ filter: `drop-shadow(0 0 10px ${color}55)` }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-[10px] uppercase tracking-[0.14em] font-semibold text-muted-foreground" style={{ maxWidth: size * 0.55, textAlign: "center", lineHeight: 1.2 }}>{label}</span>
        <span className="font-mono font-semibold leading-none mt-1" style={{ fontSize: size * 0.27 }} data-testid={`${testId}-value`}>{display ?? score}</span>
        <span className="text-xs mt-1 text-muted-foreground">/ 100</span>
        <span className="mt-2 text-xs font-semibold px-2.5 py-1 rounded-full border" data-testid={`${testId}-band`}
          style={{ color, borderColor: `${color}55`, background: `${color}1a` }}>{b}</span>
      </div>
    </div>
  );
};

export const ScoreChip = ({ score, band, testId }) => {
  if (score == null) return <span className="text-muted-foreground text-xs">—</span>;
  const color = bandColor(band || bandFor(score));
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1.5 font-mono text-sm font-semibold">
      <span className="h-2 w-2 rounded-full" style={{ background: color, boxShadow: `0 0 8px ${color}` }} />
      {score}
    </span>
  );
};
